//external
import { BreakPoint } from '@makemydeal/dr-activities-common';
import { rem } from 'polished';
import styled, { css } from 'styled-components';

export const ProductSummaryWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding-bottom: 32px;

    padding-right: ${rem(10)};
    padding-left: ${rem(10)};
    margin-top: 0;

    @media (max-width: ${BreakPoint.SMALL}) {
        align-items: stretch;
    }

    .product-amount {
        font-weight: 700;
    }
`;

export const ProductSummaryLine = styled.div`
    display: flex;
`;

export const ProductSummaryRow = styled.div`
    display: flex;
    justify-content: space-between;
    width: 200px;

    @media (max-width: ${BreakPoint.SMALL}) {
        width: 100%;
    }
`;

export const SummaryTableWrapper = styled.div<{ $hasTaxedColumn?: boolean }>`
    display: flex;
    width: ${({ $hasTaxedColumn }) => ($hasTaxedColumn ? '480px' : '390px')};

    @media (max-width: ${BreakPoint.SMALL}) {
        width: 100%;
    }
`;

export const ProductSummaryTotalCostLine = styled(ProductSummaryLine)<{ $showLegend?: boolean }>`
    ${({ $showLegend }) =>
        $showLegend &&
        css`
            width: 100%;
            justify-content: space-between;
            align-items: center;
        `}
`;

export const VppManualLegend = styled.div`
    border-left: ${({ theme }) => `${theme.tokens.BaseSizeBorderMd} solid ${theme.tokens.BaseColorGold500}`};
    padding: 0 0.6rem;
    color: ${({ theme }) => theme.tokens.BaseColorGray700};
`;
